module.exports = __webpack_public_path__ + "static/media/icon_2_2.b92db25e.svg";